export default "__VITE_ASSET__6ZAD1_OS__"